module.exports = __webpack_public_path__ + "static/media/quiz7.59c6f37e.png";